import { defineStore } from 'pinia'
import { ref } from 'vue'

/**
 * 路由参数管理 Store
 * 用于替代 router.push query/params 参数传递
 */
export const useRouteParamsStore = defineStore('routeParams', () => {
    // 存储各个页面的参数
    const params = ref<Record<string, any>>({})

    /**
     * 设置路由参数
     * @param key 参数键名（建议使用路由路径作为键名，如 '/Orderlist'）
     * @param value 参数值
     */
    const setParams = (key: string, value: any) => {
        console.log(`[RouteParams] 设置参数: ${key}`, value)
        params.value[key] = value
    }

    /**
     * 获取路由参数
     * @param key 参数键名
     * @param clear 是否在获取后清除参数（默认 true）
     * @returns 参数值
     */
    const getParams = (key: string, clear: boolean = true): any => {
        const value = params.value[key]
        console.log(`[RouteParams] 获取参数: ${key}`, value)
        
        if (clear && value !== undefined) {
            console.log(`[RouteParams] 清除参数: ${key}`)
            delete params.value[key]
        }
        
        return value
    }

    /**
     * 清除指定键的参数
     * @param key 参数键名
     */
    const clearParams = (key: string) => {
        console.log(`[RouteParams] 清除参数: ${key}`)
        delete params.value[key]
    }

    /**
     * 清除所有参数
     */
    const clearAllParams = () => {
        console.log('[RouteParams] 清除所有参数')
        params.value = {}
    }

    /**
     * 检查是否存在指定键的参数
     * @param key 参数键名
     * @returns 是否存在
     */
    const hasParams = (key: string): boolean => {
        return params.value[key] !== undefined
    }

    return {
        params,
        setParams,
        getParams,
        clearParams,
        clearAllParams,
        hasParams
    }
})

